<template>
  <div class="container mobile-border">
    <div class="mobileApp-container">
      <div class="column left-column">
        <div class="headline">
          <h4>Mobile özel fırsatları kaçırmamak için uygulamamızı indirin</h4>
          <p>30 milyondan fazla indirmeyle Türkiye'nin tercihi</p>
        </div>
        <div class="mobile-app-icons">
          <a href="https://go.onelink.me/app/8cfc1140" class="has-tooltip">
            <imageView
              :image="{
                imagePattern: appStoreImage,
              }"
              alt="Apple Store"
              :placeholder-frame="false"/>
            <span class="tooltip tooltip-with-border popover-container">
              <div class="title">Telefonunuzun kamerasını açın</div>
              <div class="qr-box">
                <div class="qrcode">
                  <imageView
                    :image="{
                      imagePattern: appStoreQRCode,
                    }"
                    :placeholder-frame="false"
                  />
                </div>
                <div
                  class="qrtext"
                >QR’ı telefonunuzun kamerasından okutarak uygulamamızı indirebilirsiniz.</div>
              </div>
            </span>
          </a>
          <a href="https://go.onelink.me/app/da805cd7" class="has-tooltip">
            <imageView
              :image="{
                imagePattern: googlePlayImage,
              }"
              :placeholder-frame="false"
              alt="Apple Store"
            />
            <span class="tooltip tooltip-with-border popover-container">
              <div class="title">Telefonunuzun kamerasını açın</div>
              <div class="qr-box">
                <div class="qrcode">
                  <imageView
                    :image="{
                      imagePattern: googlePlayStoreQRCode,
                    }"
                    :placeholder-frame="false"
                  />
                </div>
                <div class="qrtext">QR’ı telefonunuzun kamerasından okutarak uygulamamızı indirebilirsiniz.</div>
              </div>
            </span>
          </a>
          <a href="https://appgallery7.huawei.com/#/app/C100884391">
            <imageView
              class="app-gallery"
              :image="{
                imagePattern: appGalleryImage
              }"
              :placeholder-frame="false"
              alt="App Gallery"
            />
          </a>
        </div>
      </div>

      <div class="column right-column">
        <imageView
          v-if="isMobileDeviceOrScreen()"
          :image="{
            imagePattern: appMobileImage,
          }"
          :desired-size="{
            width:375,
            height: 216,
          }"
          :enablePlaceholderBgColor="false"
          class="appImage"
        />
        <imageView
          v-else
          :image="{
            imagePattern: appImage,
          }"
          :desired-size="{
            width:472,
            height: 386,
          }"
          :enablePlaceholderBgColor="false"
          class="appImage"
        />
      </div>
    </div>
  </div>
</template>

<script>
  import imageView from "../../components/imageView/imageView";

  import {isMobileDeviceOrScreen} from "../../common/agent/agentUtils.js";

  import appImage from "../../assets/images/app@2x.png";
  import appMobileImage from "../../assets/images/app-mobile2@2x.png";
  import appStoreImage from "../../assets/images/download-on-app-store.svg";
  import googlePlayImage from "../../assets/images/get-on-google-play.svg";
  import appGalleryImage from "../../assets/images/app-gallery.png";
  import appStoreQRCode from "../../assets/images/apple-app.png";
  import googlePlayStoreQRCode from "../../assets/images/google-app.png";

  import "@ckienle/k-pop/themes/clean.css";

  export default {
    name: "MobileApp",
    data() {
      return {
        appImage,
        appGalleryImage,
        appMobileImage,
        appStoreImage,
        googlePlayImage,
        appStoreQRCode,
        googlePlayStoreQRCode
      };
    },
    components: {
      imageView
    },
    methods: {
      isMobileDeviceOrScreen
    }
  };
</script>

<style src="./MobileApp.scss" lang="scss" scoped/>



// WEBPACK FOOTER //
// src/partials/MobileApp/MobileApp.vue